import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
import { QueryByType } from '../../domain/constants/QueryByType';
import { ModalMovActions } from '../../presentation/redux/actions/ModalMovActions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';

export const ModalMovCustom = () => {
  const modalState = useSelector((s: RootState) => s.modalMovState);
  const dispatch = useDispatch();
  let fecha = new Date(modalState.date);

  const handleChangeRadio = (e: any) => {
    let type = e.target.value;
    dispatch(ModalMovActions.setQueryType(type));
  }

  const handleDateChange = (date: Date) => {
    let dateEndTmp = new Date(date);
    const fechaAnterior = new Date(modalState.dateEnd.getTime());
    fechaAnterior.setMonth(fechaAnterior.getMonth() - 1);
    const fechaPosterior = new Date(modalState.dateEnd.getTime());
    fechaPosterior.setMonth(fechaPosterior.getMonth() + 1);
    dispatch(ModalMovActions.setDate(date));
    if (date < fechaAnterior) {
      dateEndTmp.setMonth(dateEndTmp.getMonth() + 1);
      dispatch(ModalMovActions.setDateEnd(dateEndTmp));
    } else if (date > fechaPosterior) {
      dispatch(ModalMovActions.setDateEnd(new Date()));
    }
  }

  const handleDateEndChange = (date: Date) => {
    dispatch(ModalMovActions.setDateEnd(date));
  }

  return (
    <div className='d-flex flex-column align-items-center'>
      <div className="radio-container mt-4">
        <div className="radio">
          <input id="rt-1" type="radio" name="rt" value={QueryByType.DATE} checked={modalState.queryType === QueryByType.DATE} onChange={handleChangeRadio} />
          <label htmlFor="rt-1">Reporte por día</label>
        </div>
        <div className="radio">
          <input id="rt-2" type="radio" name="rt" value={QueryByType.MONTH} checked={modalState.queryType === QueryByType.MONTH} onChange={handleChangeRadio} />
          <label htmlFor="rt-2">Reporte mensual</label>
        </div>
        <div className="radio">
          <input id="rt-2" type="radio" name="rt" value={QueryByType.FILTER} checked={modalState.queryType === QueryByType.FILTER} onChange={handleChangeRadio} />
          <label htmlFor="rt-2">Rango de fechas</label>
        </div>
      </div>
      {modalState.queryType === QueryByType.FILTER &&
        <div className='mt-3 col-12 text-center alert alert-info'>
          <small>El intervalo máximo permitido entre fechas es de 1 mes.</small>
        </div>
      }
      <div className='mt-4 d-flex flex-row justify-content-center'>
        {
          modalState.queryType === QueryByType.MONTH ?
            <>
              <div className='col-12'>
                <label>Selecciona un mes:</label>
                <ReactDatePicker
                  showMonthYearPicker
                  className='searchInput'
                  autoComplete='off'
                  name="date"
                  selected={modalState.date}
                  onChange={handleDateChange}
                  locale={es}
                  dateFormat="MM-yyyy"
                  placeholderText="Selecciona un mes"
                  maxDate={new Date()}
                />
              </div>
            </> :
            <div className={(modalState.queryType === QueryByType.FILTER) ? `col-6` : `col-12`}>
              <label>{(modalState.queryType === QueryByType.FILTER) ?
                `Selecciona fecha de inicio:` :
                `Selecciona un día:`}
              </label>
              <ReactDatePicker
                className='searchInput'
                autoComplete='off'
                name="date"
                selected={modalState.date}
                onChange={handleDateChange}
                locale={es}
                dateFormat="dd-MM-yyyy"
                placeholderText={(modalState.queryType === QueryByType.FILTER) ?
                  `Selecciona una fecha inicial` :
                  `Selecciona un día`}
                maxDate={new Date()}
              />
            </div>
        }
        {
          modalState.queryType === QueryByType.FILTER &&
          <>
            <div className='col-6'>
              <label>Selecciona fecha final:</label>
              <ReactDatePicker
                className='searchInput'
                autoComplete='off'
                name="dateEnd"
                selected={modalState.dateEnd}
                onChange={handleDateEndChange}
                locale={es}
                dateFormat="dd-MM-yyyy"
                placeholderText="Selecciona una fecha final"
                minDate={modalState.date}
                maxDate={new Date(fecha.setMonth(fecha.getMonth() + 1))}
              />
            </div>
          </>
        }
      </div>
    </div >
  )
}
